<template>
  <div class="main-content-container">
    <div
      class="top-content-container position-relative customer-details-top-content"
    >
      <b-row>
        <b-col cols="12">
          <b-breadcrumb class="customer-breadcrumbs">
            <b-breadcrumb-item v-if="$route.meta.assistants">
              <span
                @click="$router.push({ name: 'ViewPADirectory' })"
                class="text-uppercase font-family-medium"
              >
                Team Directory
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item
              v-if="$route.meta.assistants"
              @click="navigateToPAContact"
            >
              <span class="text-uppercase font-family-medium">
                {{ assistantFullname }}
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item @click="navigateToCustomersList">
              <span class="text-uppercase font-family-medium">
                Customers
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item @click="navigateToCustomerDetails">
              <span class="text-uppercase font-family-medium">
                {{ customerFullname }}
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item @click="navigateToPreferences">
              <span class="text-uppercase font-family-medium">
                Preferences
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span class="text-uppercase font-family-medium">
                Add Preference
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col class="mt-4 select-category-wrapper" cols="12" lg="9">
        <ValidationObserver ref="title">
          <ValidationProvider name="Title" rules="required">
            <b-form-group label="Select Category *" class="weekly-form-group">
              <b-form-select
                :disabled="disableFields"
                :options="categories"
                v-model="selectedCategory"
                @change="getSelectedCategory"
              ></b-form-select>
              <h6
                style="margin-bottom: -1.8rem"
                v-if="categoryValid === false"
                class="font-sm font-family-regular danger mt-3"
              >
                This field is required
              </h6>
            </b-form-group>
          </ValidationProvider>
        </ValidationObserver>
      </b-col>
    </b-row>
    <b-row class="">
      <b-col class="" cols="12" lg="9">
        <ValidationObserver>
          <ValidationProvider name="rte" rules="required">
            <b-form-group
              label="Description *"
              class="weekly-form-group"
            >
              <quill-editor
                ref="quillEditor"
                class="quill-custom"
                v-model="content"
                :disabled="disableFields"
                :options="editorOptions"
                @change="onEditorChange($event)"
              />
              <h6
                v-if="contentValid === false"
                style="margin-bottom: -3.4rem"
                class="font-sm font-family-regular danger ml-1 mt-4"
              >
                This field is required
              </h6>
            </b-form-group>
          </ValidationProvider>
        </ValidationObserver>
      </b-col>
    </b-row>
    <b-row class="attachment-control-wrapper">
      <b-col cols="12" lg="9" class="">
        <b-form-group class="general-info-form-group" label="Attachment">
          <b-input-group class="d-flex flex-column">
            <label class="file-select">
              <div
                class="d-flex flex-row justify-content-between w-100 p-3 cursor-pointer bg--white border-primary-lighter border-radius-sm"
              >
                <h6 class="font-sm secondary--text font-family-regular mb-0">
                  Add Attachment
                </h6>
                <img
                  class="attachment-icon"
                  src="@/assets/icons/attachments.svg"
                  alt
                />
              </div>
              <input
                type="file"
                :accept="ACCEPTED_FILE_TYPES"
                hidden
                ref="fileInput"
                :disabled="disableFields"
                @change="fileChange"
                multiple
                class="d-none"
              />
            </label>
          </b-input-group>
          <h6 class="font-sm danger" v-if="sizeExceed">
            Size cannot be greater than 500MB
          </h6>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="attachments-row">
      <b-col cols="12" lg="9">
        <b-form-group
          class="tasks-form-group"
          label="Attachments"
          v-if="attachments.length"
        >
          <div
            class="mb-5 d-flex"
            v-for="(attachment, index) in attachments"
            :key="index"
          >
            <div
              v-if="!isImage(attachment)"
              class="box-container bg--primary-light d-flex align-items-center justify-content-center"
            >
              <template v-if="!isFile(attachment)">
                <a
                  :href="attachment.attachment.attachmentFile"
                  target="_blank"
                  v-if="attachment.attachment.filetype === 'pdf'"
                >
                  <h1 class="font-lg primary--text font-family-medium">
                    {{ attachment.attachment.filetype.toUpperCase() }}
                  </h1>
                </a>
                <a
                  :download="attachment.attachment.name"
                  :title="attachment.attachment.name"
                  :href="attachment.attachment.attachmentFile"
                  v-else
                >
                  <h1 class="font-lg primary--text font-family-medium">
                    {{ attachment.attachment.filetype.toUpperCase() }}
                  </h1>
                </a>
              </template>
              <h1 v-else class="font-lg">
                <a
                  :href="URL.createObjectURL(attachment)"
                  target="_blank"
                  class="primary--text font-family-medium"
                  v-if="getFileExtension(attachment) === 'PDF'"
                >
                  {{ getFileExtension(attachment) }}</a
                >
                <a
                  :title="attachment.name"
                  class="primary--text font-family-medium"
                  :href="URL.createObjectURL(attachment)"
                  :download="attachment.name"
                  v-else
                >
                  {{ getFileExtension(attachment) }}
                </a>
              </h1>
            </div>
            <div
              v-else
              @click="onThumbnailClick(attachment, index)"
              class="box-container bg--primary-light d-flex align-items-center justify-content-center thumbnail-wrapper"
            >
              <img
                :src="attachment.attachment.thumbnail"
                v-if="attachment.attachment"
              />
              <img :src="URL.createObjectURL(attachment)" v-else />
            </div>
            <div
              class="col d-flex flex-column justify-content-center text-align-center"
            >
              <p
                class="primary--text font-family-medium position-relative attachment-text"
                v-if="attachment.attachment"
              >
                {{ `${attachment.attachment.filename}` }}
                <!-- {{ attachment.attachment.filename }} -->
              </p>
              <p class="primary--text font-family-medium" v-if="attachment.name">
                {{ `${attachment.name}` }}
              </p>
              <div>
                <b-button
                  class="btn-pill btn-danger px-4 attachment-delete-btn"
                  @click="deleteAttachment(index)"
                >
                  Delete
                </b-button>
              </div>
            </div>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="checklist-row">
      <b-col cols="12" lg="9">
        <b-form-group
          label="Checklists"
          class="tasks-form-group"
          v-if="checklists.length"
        >
          <ChecklistComponent
            :checklists="checklists"
            :isFormEnabled="true"
            @saveOption="saveChecklistOption"
            @saveTitle="saveChecklistTitle"
            @deleteChecklist="deleteChecklist"
            @deleteOption="removeOption"
            class="mb-5"
          />
        </b-form-group>
        <b-form-group
          class="mb-5 mt-5 add-view-category-form-group"
          label="Checklist"
          v-else
        >
          <b-input-group @keyup.enter="onChecklistInputEnter">
            <b-form-input
              :disabled="disableFields"
              autocomplete="off"
              class="add-category-check checklist-input"
              size="lg"
              v-model="checklistValue"
              placeholder="Add checklist"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="position-relative">
        <b-alert
          class="alert-btn-top custom-alert"
          v-if="showAlert"
          show
          :fade="true"
          >{{ alertMsg }}</b-alert
        >
      </b-col>
    </b-row>
    <b-row class="save-button-row">
      <b-col>
        <b-button
          @click="addPreference"
          :disabled="disableFields"
          class="btn-pill py-3 px-5"
        >
          <b-spinner
            v-if="isLoading"
            style="width: 14px; height: 14px"
            variant="light"
            label="Spinning"
          ></b-spinner>
          {{ `${isLoading ? "" : saveBtnText}` }}</b-button
        >
      </b-col>
    </b-row>
    <b-modal
      size="lg"
      centered
      v-model="previewModal.visible"
      content-class="preview-modal"
      :hide-header="true"
      :hide-footer="true"
    >
      <div class="preview-modal-header">
        <div class="header-text">{{ previewModalData.title }}</div>
        <b-button id="delete-button" @click="onDeleteImage">Delete</b-button>
        <b-button id="download-button" @click="onPreviewModalDownload"
          >Download</b-button
        >
        <b-button id="close-button" @click="previewModal.visible = false">
          <img src="@/assets/icons/close_sidebar.svg" />
        </b-button>
        <a
          :href="previewModalData.src"
          :title="previewModalData.title"
          :download="previewModalData.title"
          :style="{ display: 'none' }"
          ref="downloadAnchor"
        ></a>
      </div>
      <div class="preview-modal-image-wrapper">
        <img :src="previewModalData.src" />
      </div>
    </b-modal>
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      v-model="errorModal.visible"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-container fluid>
        <b-button
          @click="errorModal.visible = false"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row align-v="center" class="px-2 py-2">
          <b-col md="9" class="d-flex mb-2">
            <h4 class="font-md subtext mt-2">
              {{ errorModal.message }}
            </h4>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate/dist/vee-validate.full";
import { getCategories, getCategory, postAttachments } from "@/apis/common";
import {
  getCustomer,
  postPreferenceCheckList,
  postPreferences,
  postPreferencesAttachment
} from "@/apis/customers";
import { mapState } from "vuex";
import { getAssistantDetails } from "@/apis/assistants";
import { isFile, getFileExtension, isImage, beforeRouteLeave } from "@/utils/utils";
import { editorOptions, ACCEPTED_FILE_TYPES } from '@/utils/constants'
import store from '@/store'
import ChecklistComponent from "@/components/checklists/ChecklistComponent";

export default {
  name: "AddPreference",
  components: {
    ValidationObserver,
    ValidationProvider,
    quillEditor,
    ChecklistComponent
  },
  computed: {
    quillInstance() {
      return this.$refs.quillEditor.quill;
    },
    disableFields() {
      return this.isLoading;
    },
    previewModalData() {
      let { previewModal } = this;
      if (!previewModal.attachment) {
        return {
          src: "",
          title: "",
          thumbnail: ""
        };
      }
      if (previewModal.attachment instanceof File) {
        let blobUrl = window.URL.createObjectURL(previewModal.attachment);
        return {
          src: blobUrl,
          title: previewModal.attachment.name,
          thumbnail: blobUrl
        };
      }
      return {
        src: previewModal.attachment.attachment.attachmentFile,
        title: previewModal.attachment.attachment.filename,
        thumbnail: previewModal.attachment.attachment.thumbnail
      };
    },
    dirty() {
      if (this.saved) {
        return false
      }
      return this.selectedCategory !== null || this.content.length > 0 || this.attachments.length > 0
    },
    ...mapState("authModule", ["role", "profileUserId"])
  },
  watch: {
    dirty(isDirty) {
      if (this.saved) {
        return
      }
      const isListenerAttached = store.state.isUnloadListenerAttached
      if (isDirty && !isListenerAttached) {
        store.commit({
          type: 'attachUnloadListener',
          onBeforeUnload: this.onBeforeUnload
        })
      } 
      if(!isDirty) {
        store.commit({
          type: 'removeUnloadListener',
          onBeforeUnload: this.onBeforeUnload
        })
      }
    }
  },
  created() {
    this.trackPreferenceAdd();
    this.fetchCategoryList();
    this.customerID = this.$route.params.profileId;
    if (this.$route.params.customerFullname) {
      this.customerFullname = this.$route.params.customerFullname;
    } else {
      getCustomer(this.$route.params.profileId)
        .then(res => {
          let { firstName, lastName } = res.data.user;
          this.customerFullname = `${firstName} ${lastName}`;
        })
        .catch(err => console.log(err));
    }
    if (
      this.$route.params.assistantFullname &&
      this.$route.name === "PAAddPreference"
    ) {
      this.assistantFullname = this.$route.params.assistantFullname;
    } else if (
      !this.$route.params.assistantFullname &&
      this.$route.params.uuid
    ) {
      getAssistantDetails(this.$route.params.uuid)
        .then(res => {
          let { firstName, lastName } = res.data.user;
          this.assistantFullname = `${firstName} ${lastName}`;
        })
        .catch(err => console.log(err));
    }
  },
  data() {
    return {
      ACCEPTED_FILE_TYPES,
      errorModal: {
        visible: false,
        message: "File is empty. Cannot upload"
      },
      URL: window.URL,
      previewModal: {
        visible: false,
        src: "",
        attachment: null
      },
      sizeExceed: false,
      customerFullname: "",
      showAlert: false,
      assistantFullname: "",
      categories: [{ text: "Select Category", value: null }],
      selectedCategory: null,
      customerID: "",
      isLoading: false,
      content: "",
      attachments: [],
      preferenceID: "",
      categoryValid: true,
      saveBtnText: "Save",
      saved: false,
      editorOptions,
      contentValid: null,
      checklists: [],
      apiLoading: false,
      checklistValue: null
    };
  },

  methods: {
    isFile,
    getFileExtension,
    isImage,
    trackPreferenceAdd() {
      this.$gtag.event("Preference - Add", {
        event_category: "feature"
      });
    },
    navigateToCustomersList() {
      if (this.role === "assistant" && this.$route.meta.customers) {
        this.$router.push({
          name: "DedicatedCustomers"
        });
      } else if (this.role === "admin" && this.$route.meta.customers) {
        this.$router.push({
          name: "CustomersListAdmin",
          query: {
            tab: 0
          }
        });
      } else if (
        (this.role === "assistant" || this.role === "admin") &&
        this.$route.meta.assistants
      ) {
        this.$router.push({
          name: "PADetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 2
          }
        });
      }
    },
    navigateToCustomerDetails() {
      if (this.$route.meta.customers) {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 2
          }
        });
      } else if (this.$route.meta.assistants) {
        this.$router.push({
          name: "PACustomerDetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 2
          }
        });
      }
    },
    navigateToPreferences() {
      if (this.$route.meta.customers) {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 1
          }
        });
      } else if (this.$route.meta.assistants) {
        this.$router.push({
          name: "PACustomerDetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 1
          }
        });
      }
    },
    navigateToPAContact() {
      this.$router.push({
        name: "PADetails",
        params: {
          profileId: this.$route.params.profileId,
          uuid: this.$route.params.uuid
        },
        query: {
          tab: 1
        }
      });
    },

    fetchCategoryList() {
      getCategories()
        .then(res => {
          this.categories = [...res.data.results].map(item => {
            item.text = item.title;
            item.value = item.id;
            return item;
          });
          this.categories.unshift({
            text: "Select Category",
            value: null
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSelectedCategory(selectedId) {
      this.content = "";
      // fill up the box with the standard category questions
      let category = this.categories.find(
        category => category.id === selectedId
      );
      this.content = category.inlineQuestionnaire;

      getCategory(selectedId)
        .then(res => {
          this.checklists = res.data.checklists;
        })
        .catch(err => {
          console.log(err);
        });
    },
    removeSelectedCategory() {},
    onEditorChange({ html }) {
      this.content = html;
      let strippedContent = this.content.replace(/<(.|\n)*?>/g, "").trim();

      if (strippedContent.length === 0) {
        this.contentValid = false;
      } else {
        this.contentValid = true;
      }
    },
    addPreference() {
      let strippedContent = this.content.replace(/<(.|\n)*?>/g, "").trim();
      if (strippedContent.length === 0) {
        this.contentValid = false;
      } else {
        this.contentValid = true;
      }
      if (this.selectedCategory === null) {
        this.categoryValid = false;
      } else {
        this.categoryValid = true;
      }
      if (this.selectedCategory !== null && this.contentValid) {
        this.isLoading = true;
        const data = {
          profile: this.customerID,
          detail: this.content,
          categories: [this.selectedCategory]
        };
        postPreferences(this.customerID, data)
          .then(res => {
            this.preferenceID = res.data.id;
            for (let i = 0; i < this.attachments.length; i++) {
              if (this.attachments[i].name) {
                let myFile = new File(
                  [this.attachments[i]],
                  `${this.attachments[i].name}`
                );
                const formData = new FormData();
                formData.append("owner", this.profileUserId);
                formData.append("attachmentFile", myFile);
                postAttachments(formData).then(res => {
                  const data = {
                    preference: this.preferenceID,
                    attachment: res.data.id
                  };
                  postPreferencesAttachment(
                    this.customerID,
                    this.preferenceID,
                    data
                  ).then(() => {
                    this.showAlert = true;
                    this.alertMsg = "Saved Successfully";
                    this.isLoading = false;
                  });
                });
              }
            }
            this.createChecklist();
            this.showAlert = true;
            this.alertMsg = "Saved Successfully";
            store.commit({
              type: 'removeUnloadListener',
              onBeforeUnload: this.onBeforeUnload
            })
            this.saved = true
            this.$router.go(-1);
          })
          .catch(err => {
            if (err.response.status === 401) {
              this.showAlert = true;
              this.alertMsg =
                "User token expired. Please logout and login again";
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.showAlert = true;
        this.alertMsg = "There are invalid form fields";
      }
    },
    fileChange(event) {
      const extensions = this.ACCEPTED_FILE_TYPES
        .split(",")
        .filter(item => item[0] === '.');

      let sizing = true;
      this.sizeExceed = false;
      for (let i = 0; i < event.target.files.length; i++) {
        if (event.target.files[i].size / 1024 / 1024 > 500) {
          sizing = false;
          break;
        }
      }
      // empty file validation
      for (let file of event.target.files) {
        const fileExtension = `.${file.name.split(".").reverse()[0]}`
        const isRestrictedFileType = !extensions.includes(fileExtension)
        if (isRestrictedFileType) {
          this.errorModal.message = `${file.name} file format is not supported, please contact admin for more details.`;
          this.errorModal.visible = true;
          this.$refs.fileInput.value = "";
          return;
        }

        if (file.size === 0) {
          this.errorModal.message = `${file.name} is empty. Cannot upload.`;
          this.errorModal.visible = true;
          this.$refs.fileInput.value = "";
          return;
        }
      }
      if (sizing) {
        for (let i = 0; i < event.target.files.length; i++) {
          this.attachments.push(event.target.files[i]);
        }
      } else {
        this.sizeExceed = true;
      }
      this.$refs.fileInput.value = "";
    },
    deleteAttachment(index) {
      this.attachments.splice(index, 1);
    },
    onPreviewModalDownload() {
      // forcibly download the file
      this.$refs.downloadAnchor.click();
    },
    onThumbnailClick(attachment, attachmentIndex) {
      this.previewModal.attachment = attachment;
      this.previewModal.attachmentIndex = attachmentIndex;
      this.previewModal.visible = true;
    },
    onDeleteImage() {
      let { attachmentIndex } = this.previewModal;
      this.attachments = this.attachments.filter(
        (attachment, index) => index !== attachmentIndex
      );
      this.previewModal.visible = false;
    },
    onBeforeUnload(event) {
      event.returnValue = "Some dummy value"
    },
    createChecklist() {
      let options = [];
      if (!this.checklists.length) {
        return;
      }
      this.checklists[0].options.forEach(option => {
        options.push({ title: option.title });
      });
      let payload = {
        title: this.checklists[0].title,
        options: options
      };
      postPreferenceCheckList(this.preferenceID, payload)
        .then()
        .catch(err => {
          console.log(err);
        });
    },
    saveChecklistOption(
      newChecklistOption,
      checklistIndex,
      optionIndex,
      isNewOption
    ) {
      let checklist = this.checklists[checklistIndex];
      this.$set(checklist, "showNewOptionBox", false);
      if (isNewOption) {
        if (newChecklistOption.length > 0) {
          checklist.options.push({
            deletedAt: null,
            description: "",
            copiedFrom: checklist.category ? checklist.category : null,
            isChecked: false,
            title: newChecklistOption
          });
          this.newChecklistOption = "";
        } else {
          // if the user hasn't typed anything into the box, don't do anything, just exit
          return;
        }
      } else {
        let option = checklist.options[optionIndex];
        if (option.title.length > 0) {
          this.$set(option, "isEditing", false);
        } else {
          checklist.options = checklist.options.filter(
            (option, index) => index !== optionIndex
          );
        }
      }
    },
    optionsSortFn(optionA, optionB) {
      return optionA.position - optionB.position;
    },
    saveChecklistTitle(index, newChecklistTitle) {
      let checklist = this.checklists[index];
      if (newChecklistTitle.length > 0) {
        checklist.title = newChecklistTitle;
      }
    },
    deleteChecklist(index) {
      this.$delete(this.checklists, index);
    },
    removeOption(checklistIndex, index) {
      this.$delete(this.checklists[checklistIndex].options, index);
    },
    onChecklistInputEnter() {
      if (this.checklistValue !== "") {
        this.checklists.push({
          title: this.checklistValue,
          description: '',
          toBeDeleted: false,
          options: []
        });
      }
    }
  },
  beforeDestroy() {
    store.commit({
      type: 'removeUnloadListener',
      onBeforeUnload: this.onBeforeUnload
    })
  },
  beforeRouteLeave
};
</script>

<style scoped lang="scss">
$row-padding: 5rem;
fieldset {
  margin-bottom: 0;
}
.attachment-control-wrapper {
  padding-top: calc(#{$row-padding});
  padding-bottom: $row-padding;
  label {
    margin-bottom: 0;
  }
}
.save-button-row {
  padding-bottom: $row-padding;
  padding-top: 0rem;
}
.select-category-wrapper {
  padding-bottom: 3.5rem;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.attachments-row {
  .box-container {
    width: 17rem;
  }
}
</style>
